/**
 * Hook to track scroll depth in Google Analytics 4
 * Tracks when users scroll to 25%, 50%, 75%, and 90% of the page
 */

import { useEffect } from "react";
import { trackScrollDepth } from "../utils/analytics";

/**
 * Hook that tracks scroll depth on the current page
 *
 * Usage: Add useScrollTracking() to any page component
 */
export function useScrollTracking(): void {
  useEffect(() => {
    // Reset scroll tracking for new page
    window.scrollDepthTracked = {};

    let ticking = false;

    const handleScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          const windowHeight = window.innerHeight;
          const documentHeight = document.documentElement.scrollHeight;
          const scrollTop =
            window.scrollY || document.documentElement.scrollTop;
          const scrollPercent = Math.round(
            ((scrollTop + windowHeight) / documentHeight) * 100
          );

          trackScrollDepth(scrollPercent);
          ticking = false;
        });
        ticking = true;
      }
    };

    window.addEventListener("scroll", handleScroll, { passive: true });

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
}
